import React from 'react'
import { SlashCircle02Icon } from 'src/editor/shared/icons/slash-circle-02'
import { twMerge } from 'tailwind-merge'

interface ColorCircleProps {
  color?: string
  className?: string
  onClick?: () => void
  isEditing?: boolean
  isActive?: boolean
}

export const ColorCircle = ({
  className,
  color,
  onClick,
  isEditing = false,
  isActive = false,
}: ColorCircleProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'h-5 w-5 cursor-pointer rounded-2xl border border-border200 transition hover:border-borderInteractive',
        'flex items-center justify-center outline-borderInteractive/20 focus:outline-4',
        isActive && 'border-borderInteractive outline-4',
        className,
      )}
      style={{
        ...(color ? { backgroundColor: color } : {}),
      }}
    >
      <span
        className={twMerge(
          '-rotate-45 h-[1px] w-full bg-iconError',
          color ? 'hidden' : '',
        )}
      />
      <div
        className={twMerge(
          'm-1 rounded-full border-[0.5px] border-iconError bg-bgError p-0.5',
          !isEditing && 'hidden',
        )}
      >
        <SlashCircle02Icon />
      </div>
    </button>
  )
}
